import { FC, SVGAttributes, memo, useMemo } from 'react';
import { useColorType } from '../../libs';
import { ColorType, IconNameType } from '../../types';
import iconComponents from '../icons';

interface IHtsIconProps extends SVGAttributes<SVGElement> {
  icon: IconNameType;
  color?: ColorType;
}

export const HtslIcon: FC<IHtsIconProps> = memo(
  ({ icon, style, color = 'black', fill = 'none', ...props }) => {
    const Icon = useMemo(() => iconComponents[icon], [icon]);

    const colorType = useColorType(color);

    return <Icon {...props} style={{ fill, color: colorType, ...style }} />;
  }
);
